/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Rave2line'], function(Rave2line) {
	'use strict';
	class Rave2point extends Rave2line {
		constructor(){
			super();
		}

		get config(){
			const config = super.config;
			config.type = 'Point';

			config.slots.values.optional = false;
			config.slots.values.clientSideAggregatedAndSortInfo.groupOnColumnId = 'x';
			config.slots.values.icon = 'yAxis';
			config.slots.values.supportsMaintainAxisScale = true;

			config.properties['lines.visible'].defaultValue = false;

			config.properties['markers.visible'] =  {
				'active': false,
				'defaultValue': true,
				'isReadOnly': true
			};

			delete config.entryDurationProperty;

			delete config.properties['effect.duration'].defaultValue;

			[
				'effect.entry.line.delay',
				'effect.entry.line.duration',
				'effect.entry.line.stagger',
				'effect.entry.line.type'
			].forEach(property => delete config.properties[property]);

			const forbidden = ['line.width', 'nullValuesHandling', 'interpolate', 'effect.entry.line.type', 'effect.entry.line.delay', 'effect.entry.line.stagger', 'effect.entry.line.duration'];
			config.config.include = config.config.include.filter(property => forbidden.indexOf(property) === -1);
			config.config.exclude.push('itemAxis.labels.vertical', 'interpolate');

			return config;

		}

	}
	return Rave2point;
});